<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Political Positions</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onCreatePoliticalPosition()">
        <mat-icon>add</mat-icon>
        Add Political Position
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="politicalPositions()"
      [enableMatching]="false"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditPoliticalPosition($event)"
      (deleteClick)="onDeletePoliticalPosition($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
